// START A/B TEST PLGRWEB-1380 - Browse Filter on "All"
import DropdownFilter from 'components/dropdownFilters/DropdownFilter';

import MovieBrowse from 'components/movieBrowse';
import ShowBrowse from 'components/showBrowse';
import { trackAction } from '../../helpers/trackingOM';

export class BrowseFilterDropdown extends DropdownFilter {
    constructor(options = {}, data) {
        super(options);
        this.data = data;
        this.genreLabel = document.querySelector('.genre-label');
        this.selectedGenre = document.querySelector('#genre-text');
        this.genreDropdown = document.querySelector('#genre-dropdown');
        this.brandLabel = document.querySelector('.brand-label');
        this.selectedBrand = document.querySelector('#brand-text');
        this.brandDropdown = document.querySelector('#brand-dropdown');
        this.clearFiltersBtn = document.querySelector('.clear-filters');
        this.floatedClass = 'floated';
        this.selectedClass = 'selected';
        this.movieBrowse;
        this.showBrowse;
    }

    /**
     * set the content type depending on the page (show or movie)
     * @param string type
     */
    setContentType(type) {
        this.contentType = type;
    }

    /**
     * handle filter dropdown selection
     */
    __selectedHandler(e) {
        const target = e.target;
        let data = {};
        let selectedDropdown = '';

        if (target.classList.contains('genre-filter')) {
            // clear previously selected filter
            let selectedGenreItem = document.querySelector('.genre-filter.' + this.selectedClass);
            if (selectedGenreItem) selectedGenreItem.classList.remove(this.selectedClass);
            // set active genre from selection
            target.classList.add(this.selectedClass);
            this.genreLabel.classList.add(this.floatedClass);
            this.selectedGenre.innerHTML = target.innerText;
            data.genre = target.dataset.val;

            // get current active brand (set to empty string if none selected)
            data.brand = this.getActiveBrand();

            // track user selecting the genre filter
            selectedDropdown = this.contentType + '-genre';
        } else if (target.classList.contains('brand-filter')) {
            // clear previously selected filter
            let selectedBrandItem = document.querySelector('.brand-filter.' + this.selectedClass);
            if (selectedBrandItem) selectedBrandItem.classList.remove(this.selectedClass);
            // set active brand from selection
            target.classList.add(this.selectedClass);
            this.brandLabel.classList.add(this.floatedClass);
            this.selectedBrand.innerHTML = target.innerText;
            data.brand = target.dataset.slug;

            // get current active genre (set to empty string if none selected)
            data.genre = this.getActiveGenre();

            // track user selecting the brands filter
            selectedDropdown = this.contentType + '-brands';
        }

        this.getFilteredBrowseResults(data, selectedDropdown);
    }

    /**
     * XHR request to filter "All" movies by selected parameters
     * @param data
     */
    getFilteredBrowseResults(data, selectedDropdown) {
        // ajax request to get filtered show/movie results
        let route =
            '/' +
            this.contentType +
            's_xhr/filterResults/?genre=' +
            data.genre +
            '&brand=' +
            data.brand;

        $.ajax({
            url: route,
            dataType: 'json',
        }).done((resp) => {
            if (this.contentType === 'movie') {
                this.handleMovieResults(resp, selectedDropdown);
            } else {
                this.handleShowResults(resp, selectedDropdown);
            }
        });
        // display "clear all" active filters button
        this.clearFiltersBtn.classList.remove('hide');
    }

    /**
     * render and display movie filtered results
     * use existing movie browse component to handle response data
     * @param resp
     * @param selectedDropdown {string}
     */
    handleMovieResults(resp, selectedDropdown) {
        // use existing movie browse component to render & display grid
        this.movieBrowse = new MovieBrowse();
        this.movieBrowse.loadMore = false;
        this.movieBrowse.resp = resp;
        let movieBrowseContainer = document.querySelector(
            '.' + this.contentType + '-browse-container',
        );

        if (resp.success) {
            resp.data.forEach((item) => {
                // get total number of results found
                this.movieBrowse.number_found = item.result?.total;
            });
            // set the total results on the container
            movieBrowseContainer.setAttribute('data-movies-found', this.movieBrowse.number_found);

            // display & render the results grid
            this.movieBrowse.handleSuccess(false);

            // track results found from selections
            this.trackBrowseFilterResults(selectedDropdown);
        } else {
            // no results found, clear the grid
            this.movieBrowse.number_found = 0;
            movieBrowseContainer.setAttribute('data-movies-found', '0');
            this.movieBrowse.clearGrid();

            // display "No Results" message
            let noMovies = document.createElement('div');
            noMovies.className = 'no-filter-results';
            noMovies.innerHTML = 'No Results';
            movieBrowseContainer.append(noMovies);

            // remove movie browse bottom section
            let movieBrowseBottom = document.querySelector('#movie-browse-bottom');
            if (movieBrowseBottom) movieBrowseBottom.remove();

            // track no results found
            this.trackBrowseFilterResults(selectedDropdown, false);
        }
    }

    /**
     * render and display show filtered results
     * use existing show browse component to handle response data
     * @param resp
     * @param selectedDropdown {string}
     */
    handleShowResults(resp, selectedDropdown) {
        // use existing show browse component to render & display grid
        this.showBrowse = new ShowBrowse();
        let showBrowseContainer = document.querySelector(
            '.' + this.contentType + '-browse-container',
        );

        if (resp.success) {
            this.showBrowse.resp = resp;
            this.showBrowse.handleSuccess(false);

            // track results found from selections
            this.trackBrowseFilterResults(selectedDropdown);
        } else {
            // no results found, clear the grid
            this.showBrowse.clearGrid();

            // display "No Results" message
            let noShows = document.createElement('div');
            noShows.className = 'no-filter-results';
            noShows.innerHTML = 'No Results';
            showBrowseContainer.append(noShows);

            // track no results found
            this.trackBrowseFilterResults(selectedDropdown, false);
        }
    }

    /**
     * get active genre dropdown value if currently selected
     * @returns {string|boolean}
     */
    getActiveGenre() {
        let activeGenre = document.querySelector('.genre-filter.selected');
        if (activeGenre) {
            return activeGenre.dataset.val;
        }
        // no genre is selected
        return '';
    }

    /**
     * get active brand dropdown value if currently selected
     * @returns {string|boolean}
     */
    getActiveBrand() {
        let activeBrand = document.querySelector('.brand-filter.selected');
        if (activeBrand) {
            return activeBrand.dataset.slug;
        }
        // no brand is selected
        return '';
    }

    /**
     * event listener when user clicks "clear all" active filters
     */
    handleClearAll() {
        this.clearFiltersBtn.addEventListener('click', (e) => {
            this.trackClearAllFilters();
            this.clearActiveFilters();
            this.clearFiltersBtn.classList.add('hide');

            // re-render all browse results without any filter params
            if (this.contentType === 'movie') {
                this.movieBrowse = new MovieBrowse();
                this.movieBrowse.__setNextRouteXHR('all');
                this.movieBrowse.doAjax(false);
            } else {
                this.showBrowse = new ShowBrowse();
                this.showBrowse.__setNextRouteXHR('all');
                this.showBrowse.doAjax(false);
            }
        });
    }

    /**
     * get the filter(s) selected by the user for tracking
     * can be either the genre, brand, or concatenated list of both
     * @returns {string}
     */
    getSelectedFiltersForTracking() {
        let trackSelected = '';
        if (this.selectedGenre && this.selectedGenre.innerHTML.trim() !== '') {
            // pass currently selected genre
            trackSelected = 'GENRE - ' + this.selectedGenre.innerHTML;
        }
        if (this.selectedBrand && this.selectedBrand.innerHTML.trim() !== '') {
            let brandSelected = 'BRANDS - ' + this.selectedBrand.innerHTML;
            if (trackSelected !== '') {
                // both are selected, pass concatenated list
                trackSelected = trackSelected.concat(' | ', brandSelected);
            } else {
                // pass currently selected brand
                trackSelected = brandSelected;
            }
        }
        return trackSelected;
    }

    /**
     * clear any active filter selections and reset default dropdown styling
     */
    clearActiveFilters() {
        // remove floated labels from dropdowns
        this.removeAddedClass('.genre-label', this.floatedClass);
        this.removeAddedClass('.brand-label', this.floatedClass);

        // remove selected filter options
        this.removeAddedClass('.genre-filter', this.selectedClass);
        this.removeAddedClass('.brand-filter', this.selectedClass);
        if (this.selectedGenre) this.selectedGenre.innerHTML = '';
        if (this.selectedBrand) this.selectedBrand.innerHTML = '';
    }

    removeAddedClass(elem, filteredClass) {
        let selectedOption = document.querySelector(elem + '.' + filteredClass);
        if (selectedOption) selectedOption.classList.remove(filteredClass);
    }

    /**
     * track when user invokes the genre filter dropdown
     */
    trackGenreFilterDropdown() {
        if (this.genreDropdown) {
            this.genreDropdown.addEventListener('mouseenter', (e) => {
                e.stopPropagation();
                // on interaction with the genre filter dropdown, fire trackAction
                trackAction('trackBrowseFilterSelect', {
                    menuItemLabel: this.contentType + '-genre',
                });
            });
        }
    }

    /**
     * track when user invokes the brands filter dropdown
     */
    trackBrandsFilterDropdown() {
        if (this.brandDropdown) {
            this.brandDropdown.addEventListener('mouseenter', (e) => {
                e.stopPropagation();
                // on interaction with the brand filter dropdown, fire trackAction
                trackAction('trackBrowseFilterSelect', {
                    menuItemLabel: this.contentType + '-brands',
                });
            });
        }
    }

    /**
     * track when results are returned for currently selected genre/brand filters
     * @param selectedDropdown {string}
     * @param results {boolean}
     */
    trackBrowseFilterResults(selectedDropdown, results = true) {
        let action = 'trackBrowseFilterResults';
        if (results === false) {
            // track no results found for current selections
            action = 'trackBrowseFilterNoResults';
        }

        trackAction(action, {
            menuItemLabel: selectedDropdown,
            showPickerGenreSelected: this.getSelectedFiltersForTracking(),
        });
    }

    /**
     * track when user clears all active filters & pass currently selected genre/brand
     */
    trackClearAllFilters() {
        trackAction('trackBrowseFilterDeselect', {
            showPickerGenreSelected: this.getSelectedFiltersForTracking(),
        });
    }
}
// END A/B TEST PLGRWEB-1380 - Browse Filter on "All"
